import { render, staticRenderFns } from "./ManagerReportTab.vue?vue&type=template&id=0030ffd5&scoped=true&"
import script from "./ManagerReportTab.vue?vue&type=script&lang=js&"
export * from "./ManagerReportTab.vue?vue&type=script&lang=js&"
import style0 from "./ManagerReportTab.vue?vue&type=style&index=0&id=0030ffd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0030ffd5",
  null
  
)

export default component.exports